import * as SpanishMX from '../../../messages/es-MX';
import type { IMessages } from '../../../messages/MessageKeys';

const languageCode = SpanishMX.languageCode;
const messages: IMessages = {
	...SpanishMX.messages,
};

export { messages, languageCode };
